// ============================================================
// lazyRetry — React.lazy の chunk 読み込み失敗リトライ付きラッパー。
// 新デプロイ直後に古い chunk が 404 になる / 一時的なネット断で
// dynamic import が落ちるケースを、1回だけの全画面リロードで回復する。
// sessionStorage のフラグで無限リロードループを防ぐ
// （リロード後も失敗する＝本当に落ちている場合はエラーをそのまま投げ、
//  ErrorBoundary / コンソールに任せる）。
// ============================================================
import { lazy } from 'react';
import type { ComponentType } from 'react';

const RELOAD_FLAG = 'meeting-hub:chunk-reload';

/** `lazy(() => import('./screens/X'))` の代わりに使う。使い方は同じ。 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    factory()
      .then((mod) => {
        // 正常に読めたらフラグを消す（次回の失敗でまたリロードできるように）
        sessionStorage.removeItem(RELOAD_FLAG);
        return mod;
      })
      .catch((err: unknown) => {
        if (sessionStorage.getItem(RELOAD_FLAG)) {
          // すでに1回リロード済みでも失敗 → ループさせず素直にエラー
          throw err;
        }
        sessionStorage.setItem(RELOAD_FLAG, '1');
        window.location.reload();
        // リロードが走るまで描画を保留（resolve しない Promise を返す）
        return new Promise<{ default: T }>(() => {});
      }),
  );
}
